<ul [ngClass]="listClasses" [class.show]="isParentPath || expand">
  <ng-template ngFor let-item [ngForOf]="list" [ngForTrackBy]="trackByFunction">
    <app-nav-list-item [config]="item" (open)="handleOpen($event)"></app-nav-list-item>
    <app-nav-list
      *ngIf="item.children"
      [expand]="expandChildren"
      [list]="item.children"
      [listClasses]="{ 'list-unstyled': true, 'sub-menu': true }"></app-nav-list>
  </ng-template>
</ul>
